import axios from 'axios';

const apiClient = axios.create({
  // baseURL: 'http://localhost:8000', // Localhost URL for development
  baseURL: 'https://webchat-backend-99d86c6250c4.herokuapp.com/', // Heroku URL for production
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
